var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-container"},[_c('p',{staticClass:"notice"},[_vm._v("Streamline: In Active Development")])])
}]

export { render, staticRenderFns }